module.exports = __webpack_public_path__ + "img/orangeMan.328bf4e3.png";